<template>
  <div class="row">
    <div class="form-group col-md-12 text-right">
      <button
        type="button"
        class="btn btn-primary btn-sm"
        data-toggle="modal"
        data-target="#modal_detalle"
        @click="getDatosModal()"
        v-if="$store.getters.can('tep.nominaciones.edit')"
      >
        <i class="fas fa-plus"></i>
      </button>
    </div>

    <table
      class="
        table table-bordered table-striped table-hover
        text-nowrap
        table-sm
      "
    >
      <thead class="thead-dark">
        <tr>
          <th class="text-center">Tipo Operación</th>
          <th class="text-center">Tipo de Vehículo</th>
          <th class="text-center">Transportadora</th>
          <th class="text-center">Turno</th>
          <th class="text-center">Centro contable</th>
          <th class="text-center">CECO/AFE</th>
          <th class="text-center">%</th>
          <th class="text-center">Responsable/Dueño</th>
          <th class="text-center">Cantidad</th>
          <th class="text-center" style="width: 120px">Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="detalle in $parent.nominacion.tep_det_nominacion"
          :key="detalle.id"
        >
          <td>
            <i
              v-if="detalle.tep_itinerario_id && detalle.tep_nominacion_id"
              class="fas fa-circle text-primary mr-2"
            ></i>
            {{ detalle.nTipoOperacion }}
            <strong>{{ detalle.area ? `(${detalle.nArea})` : "" }}</strong>
          </td>
          <td>{{ detalle.tep_tipos_vehiculos.nombre }}</td>
          <td>{{ detalle.tep_transportadora.razon_social }}</td>
          <td>{{ detalle.turno.nombre }}</td>
          <td class="text-center">{{ detalle.nCentroContable || "—" }}</td>
          <td class="text-center">
            {{ (detalle.ceco_afe && detalle.ceco_afe.codigo_contable) || "—" }}
          </td>
          <td class="text-center">
            {{ detalle.porcentaje != null ? detalle.porcentaje + "%" : "—" }}
          </td>
          <td class="text-center">
            {{ nombreResponsable(detalle.responsable) || "—" }}
          </td>
          <td class="text-center">{{ detalle.cantidad_vehiculo }}</td>
          <td class="text-right">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-sm bg-navy"
                data-toggle="modal"
                data-target="#modal_detalle"
                @click="getDatosModal(detalle)"
                v-if="$store.getters.can('tep.nominaciones.edit')"
              >
                <i class="fas fa-edit"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger"
                @click="destroy(detalle)"
                v-if="
                  $store.getters.can('tep.nominaciones.edit') &&
                    $parent.permite_editar
                "
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="modal_detalle"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Detalle</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="form-group col-md-4">
                <label>Tipo Operación</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_operacion"
                  :class="
                    $v.form.tipo_operacion.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  :disabled="!$parent.permite_editar"
                  @change="validaRepetido()"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_operacion in $parent.listasForms.tipo_operacion"
                    :key="tipo_operacion.numeracion"
                    :value="tipo_operacion.numeracion"
                  >
                    {{ tipo_operacion.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-8">
                <div v-if="form.tipo_operacion && form.tipo_operacion == 2">
                  <label>Área</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="form.area"
                    :class="$v.form.area.$invalid ? 'is-invalid' : 'is-valid'"
                    :disabled="!$parent.permite_editar"
                    @change="validaRepetido()"
                  >
                    <option value="">Seleccione...</option>
                    <option
                      v-for="area in $parent.listasForms.areas"
                      :key="area.numeracion"
                      :value="area.numeracion"
                    >
                      {{ area.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Tipo Vehículo</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_vehiculo"
                  :class="
                    $v.form.tipo_vehiculo.$invalid ? 'is-invalid' : 'is-valid'
                  "
                  :disabled="!$parent.permite_editar"
                  @change="validaRepetido()"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_vehiculo in $parent.listasForms.tipo_vehiculo"
                    :key="tipo_vehiculo.id"
                    :value="tipo_vehiculo.id"
                  >
                    {{ tipo_vehiculo.nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-8">
                <label>Transportadora</label>
                <v-select
                  :class="[
                    $v.form.transportadora.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="form.transportadora"
                  placeholder="Transportadora"
                  label="razon_social"
                  :options="optionsTransportadoras"
                  class="form-control form-control-sm p-0"
                  :disabled="!$parent.permite_editar"
                  @input="onTransportadoraChange()"
                ></v-select>
              </div>
              <div class="form-group col-md-6">
                <label>Turno</label>
                <v-select
                  :class="[
                    $v.form.turno.$invalid ? 'is-invalid' : 'is-valid',
                    $store.getters.getDarkMode ? 'dark-vselect' : '',
                  ]"
                  v-model="form.turno"
                  placeholder="Turno"
                  label="nombre"
                  :options="optionsTurnos"
                  class="form-control form-control-sm p-0"
                  :disabled="
                    !$parent.permite_editar ||
                      !form.transportadora ||
                      !form.transportadora.id
                  "
                  @input="validaRepetido()"
                ></v-select>
                <div
                  v-if="
                    form.transportadora &&
                      form.transportadora.id &&
                      optionsTurnos.length === 0
                  "
                  class="alert alert-warning py-2 mt-2 mb-0"
                >
                  <i class="fas fa-exclamation-triangle mr-1"></i>
                  No existen turnos configurados para esta transportadora en el sitio seleccionado.
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>Centro contable</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.centro_contable"
                  :disabled="!$parent.permite_editar"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="centro in $parent.listasForms.centros_contable"
                    :key="centro.numeracion"
                    :value="centro.numeracion"
                  >
                    {{ centro.descripcion }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Responsable/Dueño</label>
                <v-select
                  :class="[$store.getters.getDarkMode ? 'dark-vselect' : '']"
                  v-model="form.responsable"
                  placeholder="Responsable / Dueño"
                  label="funcionario"
                  :options="optionsResponsables"
                  class="form-control form-control-sm p-0"
                  :disabled="!$parent.permite_editar"
                  :clearable="true"
                ></v-select>
              </div>
              <div class="form-group col-md-4">
                <label>Tipo (CECO/AFE)</label>
                <select
                  class="form-control form-control-sm"
                  v-model="form.tipo_presupuesto"
                  :disabled="!$parent.permite_editar"
                  @change="onTipoPresupuestoChange()"
                >
                  <option value="">Seleccione...</option>
                  <option value="1">AFE</option>
                  <option value="2">CECO</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>CECO/AFE</label>
                <v-select
                  :class="[$store.getters.getDarkMode ? 'dark-vselect' : '']"
                  v-model="form.ceco_afe"
                  placeholder="CECO / AFE"
                  label="codigo_contable"
                  :options="optionsCecosAfes"
                  class="form-control form-control-sm p-0"
                  :disabled="!$parent.permite_editar || !form.tipo_presupuesto"
                  :clearable="true"
                ></v-select>
              </div>
              <div class="form-group col-md-4">
                <label>% de la operación</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  class="form-control form-control-sm"
                  v-model="form.porcentaje"
                  placeholder="0"
                  :disabled="!$parent.permite_editar"
                />
              </div>
              <div class="form-group col-md-6">
                <label>Cantidad de vehículos</label>
                <input
                  type="number"
                  class="form-control form-control-sm"
                  v-model="form.cantidad_vehiculo"
                  :class="
                    $v.form.cantidad_vehiculo.$invalid
                      ? 'is-invalid'
                      : 'is-valid'
                  "
                  @blur="validaLimiteVehiculos()"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              @click="save()"
              v-if="
                $store.getters.can('tep.nominaciones.edit') && !$v.form.$invalid
              "
            >
              Guardar
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "NominacionDetalles",
  components: {
    vSelect,
  },
  data() {
    return {
      cargando: false,
      limite_vehiculos: null,
      form: {
        id: null,
        tep_nominacion_id: this.$parent.nominacion.id,
        tipo_operacion: null,
        area: null,
        tipo_vehiculo: null,
        cantidad_vehiculo: null,
        turno: null,
        transportadora: null,
        centro_contable: null,
        tipo_presupuesto: null,
        ceco_afe: null,
        porcentaje: null,
        responsable: null,
      },
      listasForms: {
        sitios: [],
        estados: {},
      },
      opcionesTurnos: [],
    };
  },
  computed: {
    optionsTurnos() {
      return Array.isArray(this.opcionesTurnos) ? this.opcionesTurnos : [];
    },
    optionsTransportadoras() {
      const list =
        this.$parent.listasForms && this.$parent.listasForms.transportadoras;
      return Array.isArray(list) ? list : [];
    },
    optionsResponsables() {
      const list =
        this.$parent.listasForms && this.$parent.listasForms.responsables;
      return Array.isArray(list) ? list : [];
    },
    optionsCecosAfes() {
      const list =
        this.$parent.listasForms && this.$parent.listasForms.cecos_afes;
      return Array.isArray(list) ? list : [];
    },
  },
  validations() {
    if (this.form.tipo_operacion != 2) {
      return {
        form: {
          tipo_operacion: {
            required,
          },
          tipo_vehiculo: {
            required,
          },
          cantidad_vehiculo: {
            required,
          },
          transportadora: {
            required,
          },
          turno: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          tipo_operacion: {
            required,
          },
          area: {
            required,
          },
          tipo_vehiculo: {
            required,
          },
          cantidad_vehiculo: {
            required,
          },
          transportadora: {
            required,
          },
          turno: {
            required,
          },
        },
      };
    }
  },

  methods: {
    getDatosModal(detalle = null) {
      this.resetForm();
      if (detalle) {
        this.form = {
          id: detalle.id,
          tep_nominacion_id: this.$parent.nominacion.id,
          tipo_operacion: detalle.tipo_operacion,
          area: detalle.area,
          tipo_vehiculo: detalle.tep_tipos_vehiculos.id,
          cantidad_vehiculo: detalle.cantidad_vehiculo,
          turno: detalle.turno,
          transportadora: detalle.tep_transportadora,
          centro_contable: detalle.centro_contable ?? null,
          tipo_presupuesto: detalle.tipo_presupuesto ?? null,
          ceco_afe: detalle.ceco_afe || null,
          porcentaje: detalle.porcentaje ?? null,
          responsable: this.normalizarResponsableParaSelect(
            detalle.responsable,
          ),
        };
        this.limite_vehiculos = detalle.cantidad_vehiculo;
        if (this.form.tipo_presupuesto) {
          this.$parent.getCecosAfes(this.form.tipo_presupuesto);
        }
        if (this.form.transportadora && this.form.transportadora.id) {
          this.cargarTurnos(this.form.transportadora.id);
        }
      } else {
        this.opcionesTurnos = [];
      }
    },

    cargarTurnos(empresaId) {
      const parent = this.$parent;
      const sitioId =
        (parent.form && parent.form.sitio && parent.form.sitio.id) ||
        (parent.nominacion &&
          parent.nominacion.sitio &&
          parent.nominacion.sitio.id);
      if (!sitioId || !empresaId) {
        this.opcionesTurnos = [];
        return;
      }

      console.log("sitioId", sitioId);
      console.log("empresaId", empresaId);

      axios
        .get("/api/tep/nominaciones/contratoTurno", {
          params: { sitio_id: sitioId, empresa_id: empresaId },
        })
        .then((response) => {
          const data = response.data;
          this.opcionesTurnos = Array.isArray(data) ? data : [];

          console.log("TURNOS CARGADOS =>", this.opcionesTurnos);
        })
        .catch(() => {
          this.opcionesTurnos = [];
        });
    },

    onTransportadoraChange() {
      if (!this.form.transportadora || !this.form.transportadora.id) {
        this.form.turno = null;
        this.opcionesTurnos = [];
        return;
      }
      this.form.turno = null;
      this.cargarTurnos(this.form.transportadora.id);
    },

    async validaRepetido() {
      const form = this.form;
      if (!form.transportadora || !form.transportadora.id) {
        return;
      }
      await this.$parent.getTurnos(form.transportadora.id);
      if (
        form.tipo_operacion &&
        form.tipo_vehiculo &&
        form.turno &&
        form.transportadora &&
        form.area
      ) {
        const data = this.$parent.nominacion.tep_det_nominacion;
        data.forEach((detalle) => {
          if (
            form.tipo_operacion == detalle.tipo_operacion &&
            form.tipo_vehiculo == detalle.tipo_vehiculo &&
            form.turno.id == detalle.turno_id &&
            form.transportadora.id == detalle.empresa_id &&
            form.area == detalle.area
          ) {
            form.transportadora = null;
            this.$swal({
              icon: "error",
              title: `Ya existe un detalle nominación con los datos ingresados.`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            return false;
          }
        });
      }

      // Se valida si se debe dejar el campo de área diligenciado
      if (form.tipo_operacion && form.tipo_operacion != 2) {
        form.area = null;
      }
    },

    validaLimiteVehiculos() {
      if (this.limite_vehiculos) {
        if (
          this.form.cantidad_vehiculo < this.limite_vehiculos &&
          !this.$parent.permite_editar
        ) {
          this.$swal({
            icon: "error",
            title: `Se debe postular una cantidad mayor de vehículos a la ya existente.`,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.form.cantidad_vehiculo = this.limite_vehiculos;
        }
      }
    },

    resetForm() {
      this.limite_vehiculos = null;
      this.opcionesTurnos = [];
      this.form = {
        id: null,
        tep_nominacion_id: this.$parent.nominacion.id,
        tipo_operacion: null,
        area: null,
        tipo_vehiculo: null,
        cantidad_vehiculo: null,
        transportadora: null,
        turno: null,
        centro_contable: null,
        tipo_presupuesto: null,
        ceco_afe: null,
        porcentaje: null,
        responsable: null,
      };
    },

    nombreResponsable(resp) {
      if (!resp) return "";
      if (resp.funcionario) return resp.funcionario;
      if (resp.nombres) return resp.nombres;
      if (resp.name) return resp.name;
      return resp.nombres && resp.apellidos
        ? `${resp.nombres} ${resp.apellidos}`
        : "";
    },

    normalizarResponsableParaSelect(resp) {
      if (!resp || !resp.id) return null;
      const nombre =
        resp.funcionario ||
        [resp.nombres, resp.apellidos]
          .filter(Boolean)
          .join(" ")
          .trim();
      return { id: resp.id, funcionario: nombre || "Sin nombre" };
    },

    onTipoPresupuestoChange() {
      this.form.ceco_afe = null;
      this.$parent.getCecosAfes(this.form.tipo_presupuesto);
    },

    // Acciones de formualrios
    save() {
      this.$parent.cargando = true;
      if (!this.$v.form.$invalid) {
        this.cargando = true;
        const payload = { ...this.form };
        payload.empresa_id = this.form.transportadora.id;
        payload.turno_id = this.form.turno.id;
        payload.ceco_afe_id = this.form.ceco_afe ? this.form.ceco_afe.id : null;
        payload.responsable_id = this.form.responsable
          ? this.form.responsable.id
          : null;
        payload.tipo_presupuesto = this.form.tipo_presupuesto || null;
        payload.porcentaje =
          this.form.porcentaje != null && this.form.porcentaje !== ""
            ? parseFloat(this.form.porcentaje)
            : null;
        delete payload.transportadora;
        delete payload.turno;
        delete payload.ceco_afe;
        delete payload.responsable;
        axios({
          method: "POST",
          url: "/api/tep/nominaciones/detalle",
          data: payload,
        })
          .then((response) => {
            this.$parent.cargando = false;
            this.$refs.closeModal.click();
            this.$parent.nominacion.tep_det_nominacion =
              response.data.tep_det_nominacion;
            this.$parent.cant_detalles =
              response.data.tep_det_nominacion.length;
            this.$swal({
              icon: "success",
              title:
                "Se actualizó el detalle de la nominación correctamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.$parent.cargando = false;
            this.$swal({
              icon: "error",
              title: `Ha ocurrido un error: ${e.response.data.message}`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(detalle) {
      this.$swal({
        title: "Esta seguro de eliminar el detalle de nominación?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          this.$parent.cargando = true;
          axios
            .delete("/api/tep/nominaciones/detalle/" + detalle.id)
            .then((response) => {
              this.$parent.cargando = false;
              this.$parent.nominacion.tep_det_nominacion =
                response.data.tep_det_nominacion;
              this.$parent.cant_detalles =
                response.data.tep_det_nominacion.length;
              if (this.$parent.cant_detalles == 0) {
                this.$parent.form.estado = 1;
              }
              this.$swal({
                icon: "success",
                title: "Se eliminó el detalle de la nominación exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
  },
};
</script>
